
class Level {

  constructor(model) {

    this.transition = function (properties, duration = 350, ease = 'cubic-in-out') {
      model.transition(properties, duration, ease)
      return this
    }

    this.translate = function (x, y) {
      model.translate(x, y)
      return this
    }

    this.show = function() {
      model.show()
      return this
    }

    this.hide = function() {
      model.hide()
      return this
    }

    this.opacity = function (opacity) {
      model.opacity(opacity)
      return this
    }

    this.data = function () {
      return model.data()
    }
  }
}

export default Level
